import React, { Component } from 'react';
import { CardBody, Col, Row, Button, Label } from 'reactstrap';
import { withTranslation } from "react-i18next";
import * as BB from "../../../../components/BBComponent";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as loadingActions from "../../../../redux/actions/loadingActions";
import * as poolActions from "../../../../redux/actions/poolActions";
import { CustomCard } from "../../../../components/custom";
import jwt_decode from 'jwt-decode';
import Modal from "reactstrap/es/Modal";
import ModalHeader from "reactstrap/es/ModalHeader";
import ModalBody from "reactstrap/es/ModalBody";
import notify from "devextreme/ui/notify";
import { useState, useEffect } from "react";


import {
    callAPI,
    callApiGet,
    callApiPost,
    callApiPut
} from "../../../../components/Axios";
class TaskPool extends Component {
    constructor(props) {
        super(props);

        var token = localStorage.getItem("token");
        var user = jwt_decode(token);

        this.state = {
            collapse: true,
            fadeIn: true,
            timeout: 50,
            poolTasks: [],
            currentTask: [],
            talepEden: '',
            firma: '',
            departman: '',
            gorev: '',
            kategori: '',
            aciklama: '',
            aciliyet: '',
            etki: '',
            showOwnTask: false,
            showDetail: false,
            gridData: [],
            loginUser: user,
            isAssignJob: false,
            poolUsers: [],
            selectedUserId: undefined,
            selectedMessage: '',
            taskID: undefined,
            jobResponseUser: undefined,
            buttonVisible: "block",
            acceptDelete: "none",
            myPools: undefined,
            selectedPools: "00000000-0000-0000-0000-000000000000",
            isMobile: window.innerWidth <= 768,
            jsonData: [],
            visibleColumns: []
        };
        let { t } = this.props;
        this.gridRef = React.createRef();
        this.languages = {
            hata: t("hata"),
            onayVer: t("onayVer"),
            iptal: t("iptal"),
            bilgimdeOlanTalepler: t("bilgimdeOlanTalepler"),
            onayladıgımTalepler: t("onayladığımTalepler"),
            reddettiğimTalepler: t("reddettiğimTalepler"),
            oluşturduğumTalepler: t("oluşturduğumTalepler"),
            üzerimdekiTalepler: t("üzerimdekiTalepler"),
            ekibinÜzerindekiTalepler: t("ekibinÜzerindekiTalepler"),
            tamamlananTalepler: t("tamamlananTalepler"),
            firma: t("firma"),
            uygula: t("uygula"),
            vazgec: t("vazgec"),
            vazgec2: t("talepAciklamasi"),
            devral: t("devral"),
            tamam: t("tamam"),
            toplamTalepSayisi: t("toplamTalepSayisi"),
            talebinizBaşkaBirKullanıcıTarafındanDevranıldığıİçinBuTalepÜzerindeİptalİşlemiYapamazsınız: t("talebinizBaşkaBirKullanıcıTarafındanDevranıldığıİçinBuTalepÜzerindeİptalİşlemiYapamazsınız!"),
            Görevbaşarıylasilindi: t("Görevbaşarıylasilindi"),
            talebiDevralacaksiniz: t("talebiDevralacaksiniz"),
            onayAciklamasiGiriniz: t("onayAciklamasiGiriniz"),
            iptalAciklamasiGiriniz: t("iptalAciklamasiGiriniz"),
            onayBasariylaVerilmistir: t("onayBasariylaVerilmistir"),
            talepBasariylaIptalEdilmistir: t("talepBasariylaIptalEdilmistir"),
            talepBasariylaDevredildi: t("talepBasariylaDevredildi"),
            havuzAlaniZorunludur: t("havuzAlaniZorunludur"),
            durumAlaniZorunludur: t("durumAlaniZorunludur"),
            talepDurumDegistirmeBasarili: t("talepDurumDegistirmeBasarili"),
            aciklamaAlaniZorunludur: t("aciklamaAlaniZorunludur"),
            dosyaEklemeZorunludur: t("dosyaEklemeZorunludur"),
            hizliTalepOlusturAciklama: t("hizliTalepOlusturAciklama"),
            iptalAciklamasıGiriniz: t("iptalAciklamasiGiriniz"),
            toplamTalepSayisi: t("toplamTalepSayisi"),
            oluşturmaBaşlangıçTarihi: t("oluşturmaBaşlangıçTarihi"),
            kapanışBaşlangıçTarihi: t("kapanışBaşlangıçTarihi"),
            detaylıFiltre: t("detaylıFiltre"),
            kapanışBitişTarihi: t("kapanışBitişTarihi"),
            kapananlarıDahilEt: t("kapananlarıDahilEt"),
            oluşturmaBitişTarihi: t("oluşturmaBitişTarihi"),
            işlemDurumu: t("işlemDurumu"),
            talepDurumu: t("talepDurumu"),
            talepBasariylaSonlandirildi: t("talepBasariylaSonlandirildi"),
            ProjeNumarası: t("ProjeNumarası"),
            sonlandirmaAciklamasiAlaniZorunludur: t(
                "sonlandirmaAciklamasiAlaniZorunludur"
            ),
            talepBasariylaIptalEdilmistir: t("talepBasariylaIptalEdilmistir"),
            talebinAciliyetiBasariylaDegistirildi: t(
                "talebinAciliyetiBasariylaDegistirildi"
            ),
            talebinAciliyetiDegistirilirkenHataAlindi: t(
                "talebinAciliyetiDegistirilirkenHataAlindi"
            ),
            talepHavuuzu: t("talepHavuuzu"),
            görevatanamadi: t("görevatanamadi"),
            Görevbaşarıylaatandı: t("Görevbaşarıylaatandı"),
            SütunlarbaşarıylaKaydedildi: t("Sütunlar Başarıyla Kaydedildi"),
        };
    }

    fetchJsonValueFromDatabase = async (userID, screenType) => {
        try {
            const response = await fetch(`/api/Task/GetColumnSelectors?userID=${userID}&screenType=${screenType}`);
            if (!response.ok) {
                throw new Error('Veri alınırken hata oluştu');
            }

            const jsonValue = await response.json();
            
            // ✅ Eğer DB'den veri gelmezse (null, boş array, veya JsonValue null), default değerlerle yeni kayıt oluştur
            if (!jsonValue || (Array.isArray(jsonValue) && jsonValue.length === 0) || (Array.isArray(jsonValue) && jsonValue[0] && !jsonValue[0].JsonValue)) {
                console.log('DB\'de kayıt yok veya JsonValue null, default değerler ile yeni kayıt oluşturuluyor...');
                
                const allColumns = [
                    "TaskNumber", "GorevCount", "CompanyName", "CreateUserCompanyDepartmentJobName",
                    "CreateUserName", "AciklamaCount", "ParentCategory", "Category.Name", "DegreeOfUrgency",
                    "NewDescription", "EkdosyaCount", "CreateDate", "ManagerUserName", "ExpectedEndDate",
                    "TerminationDescription", "CreateUserCompanyDepartmentName", "SlaMinute", "ApprovalDate", "StatusName", "WorkStatus.Name", "ResponsibleUserName",
                    "PoolName", "ProjectNumber", "TaskTerminationDescription", "TerminationDate"
                ];
                
                const defaultVisibility = {
                    "TaskNumber": true,
                    "GorevCount": true,
                    "CompanyName": true,
                    "CreateUserCompanyDepartmentJobName": false,
                    "CreateUserName": true,
                    "AciklamaCount": true,
                    "ParentCategory": true,
                    "Category.Name": true,
                    "DegreeOfUrgency": true,
                    "NewDescription": false,
                    "EkdosyaCount": true,
                    "CreateDate": true,
                    "ManagerUserName": false,
                    "ExpectedEndDate": true,
                    "TerminationDescription": true,
                    "CreateUserCompanyDepartmentName": false,
                    "SlaMinute": false,
                    "ApprovalDate": false,
                    "StatusName": true,
                    "WorkStatus.Name": false,
                    "ResponsibleUserName": false,
                    "PoolName": true,
                    "ProjectNumber": true,
                    "TaskTerminationDescription": true,
                    "TerminationDate": true
                };
                
                const normalized = {};
                allColumns.forEach((field, idx) => {
                    normalized[field] = {
                        visible: defaultVisibility[field] !== undefined ? defaultVisibility[field] : true,
                        visibleIndex: idx,
                        width: null
                    };
                });
                
                const defaultJsonValue = JSON.stringify(normalized);
                const defaultData = [{
                    JsonValue: defaultJsonValue,
                    IsActive: true
                }];
                
                // DB'ye yeni kayıt ekle
                const payload = {
                    UserID: userID,
                    JsonValue: defaultJsonValue,
                    ScreenType: screenType
                };
                
                try {
                    const saveResponse = await fetch('/api/Task/UpdateColumnChooser', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(payload)
                    });
                    
                    if (saveResponse.ok) {
                        console.log('Default kolon ayarları başarıyla DB\'ye kaydedildi');
                    } else {
                        console.error('Default kolon ayarları DB\'ye kaydedilemedi');
                    }
                } catch (saveError) {
                    console.error('DB kayıt hatası:', saveError);
                }
                
                this.setState({ jsonData: defaultData });
                return defaultData;
            }
            
            // DB'den gelen legacy/bozuk kayıtları normalize et
            const normalized = this.normalizeColumnsFromDb('TaskPool', jsonValue);
            this.setState({ jsonData: normalized });
            
            // Normalize ettiysek DB'ye geri yaz (sessiz migrasyon)
            if (Array.isArray(jsonValue) && Array.isArray(normalized) && jsonValue[0]?.JsonValue !== normalized[0]?.JsonValue) {
                const payload = {
                    UserID: userID,
                    JsonValue: normalized[0].JsonValue,
                    ScreenType: screenType
                };
                fetch('/api/Task/UpdateColumnChooser', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(payload)
                }).catch(() => null);
            }
            return jsonValue;
        } catch (error) {
            console.error("JsonValue alınırken hata oluştu:", error);
            return null;
        }
    };
    normalizeColumnsFromDb = (screenType, dbList) => {
        try {
            if (!Array.isArray(dbList) || dbList.length === 0) return dbList;
            const item = { ...dbList[0] };
            const allColumns = [
                "TaskNumber", "GorevCount", "CompanyName", "CreateUserCompanyDepartmentJobName",
                "CreateUserName", "AciklamaCount", "ParentCategory", "Category.Name", "DegreeOfUrgency",
                "NewDescription", "EkdosyaCount", "CreateDate", "ManagerUserName", "ExpectedEndDate",
                "TerminationDescription", "CreateUserCompanyDepartmentName", "SlaMinute", "ApprovalDate", "StatusName", "WorkStatus.Name", "ResponsibleUserName",
                "PoolName", "ProjectNumber", "TaskTerminationDescription", "TerminationDate"
            ];
            
            // Default görünürlükleri (Müşteri tarafından belirlenen)
            const defaultVisibility = {
                "TaskNumber": true,
                "GorevCount": true,
                "CompanyName": true,
                "CreateUserCompanyDepartmentJobName": false,
                "CreateUserName": true,
                "AciklamaCount": true,
                "ParentCategory": true,
                "Category.Name": true,
                "DegreeOfUrgency": true,
                "NewDescription": false,
                "EkdosyaCount": true,
                "CreateDate": true,
                "ManagerUserName": false,
                "ExpectedEndDate": true,
                "TerminationDescription": true,
                "CreateUserCompanyDepartmentName": false,
                "SlaMinute": false,
                "ApprovalDate": false,
                "StatusName": true,
                "WorkStatus.Name": false,
                "ResponsibleUserName": false,
                "PoolName": true,
                "ProjectNumber": true,
                "TaskTerminationDescription": true,
                "TerminationDate": true
            };
            
            const renameMap = { ClosingDate: 'ExpectedEndDate' };
            let parsed;
            try { 
                parsed = item.JsonValue ? JSON.parse(item.JsonValue) : null; 
            } catch { 
                // JSON parse hatası - varsayılan değerleri kullan
                return this.createDefaultColumnState(item, allColumns, defaultVisibility);
            }
            
            // JsonValue null ise veya boş obje ise varsayılan değerleri kullan
            if (!parsed || Object.keys(parsed).length === 0) {
                return this.createDefaultColumnState(item, allColumns, defaultVisibility);
            }
            
            // Eski format kontrolü: Tüm değerler boolean ise ve hiçbiri object değilse eski formattır
            const isOldFormat = Object.values(parsed).every(v => typeof v === 'boolean' || v === null || v === undefined);
            
            if (isOldFormat) {
                console.log('Eski format veri tespit edildi, default değerler kullanılıyor');
                return this.createDefaultColumnState(item, allColumns, defaultVisibility);
            }
            
            const normalized = {};
            allColumns.forEach((field, idx) => {
                const sourceKey = (parsed[field] !== undefined) ? field : (renameMap[field] ? renameMap[field] : field);
                let v = parsed[field];
                if (v === undefined && renameMap[field]) {
                    v = parsed[renameMap[field]];
                }
                
                if (v && typeof v === 'object') {
                    normalized[field] = {
                        visible: typeof v.visible === 'boolean' ? v.visible : defaultVisibility[field] || false,
                        visibleIndex: Number.isFinite(v.visibleIndex) ? v.visibleIndex : idx,
                        width: (v.width !== undefined ? v.width : null)
                    };
                } else if (typeof v === 'boolean') {
                    normalized[field] = { 
                        visible: v, 
                        visibleIndex: idx, 
                        width: null 
                    };
                } else {
                    // Kayıt yoksa default görünürlük: Default grid'deki görünürlükleri kullan
                    normalized[field] = { 
                        visible: defaultVisibility[field] !== undefined ? defaultVisibility[field] : true, 
                        visibleIndex: idx, 
                        width: null 
                    };
                }
            });
            item.JsonValue = JSON.stringify(normalized);
            return [item];
        } catch (e) {
            console.error('normalizeColumnsFromDb hatası:', e);
            return dbList;
        }
    }
    
    // Varsayılan kolon durumu oluştur
    createDefaultColumnState = (item, allColumns, defaultVisibility) => {
        const normalized = {};
        allColumns.forEach((field, idx) => {
            normalized[field] = { 
                visible: defaultVisibility[field] !== undefined ? defaultVisibility[field] : true, 
                visibleIndex: idx, 
                width: null 
            };
        });
        item.JsonValue = JSON.stringify(normalized);
        return [item];
    }

    // Legacy localStorage fallback: DB kaydı yoksa eski local grid state'i oku
    loadLegacyColumnsFromLocalStorage = (storageKey) => {
        try {
            const raw = window.localStorage.getItem(storageKey) || window.localStorage.getItem('storage');
            if (!raw) return null;
            const parsed = JSON.parse(raw);
            const columns = parsed?.columns;
            if (!Array.isArray(columns) || columns.length === 0) return null;
            const columnsState = {};
            columns.forEach(col => {
                const dataField = col?.dataField;
                if (!dataField) return;
                columnsState[dataField] = {
                    visible: typeof col.visible === 'boolean' ? col.visible : true,
                    visibleIndex: Number.isFinite(col.visibleIndex) ? col.visibleIndex : null,
                    width: (col.width !== undefined ? col.width : null)
                };
            });
            return [{ JsonValue: JSON.stringify(columnsState), IsActive: true }];
        } catch (e) {
            console.warn('Legacy localStorage okunamadı:', e);
            return null;
        }
    }

    async componentDidMount() {
        await this.getData();
        this.getMyPoolUser();
        this.getMyPools();
        window.addEventListener("resize", this.handleResize);
        this.handleResize();
        const visibleColumns = this.getVisibleColumns();
        this.setState({ visibleColumns });
        const screenType = 'TaskPool';
        const userID = this.state.loginUser.ID;
        const jsonValue = await this.fetchJsonValueFromDatabase(userID, screenType)

        // DB boş ise legacy localStorage fallback uygula (eski kullanıcılar)
        if (!jsonValue || (Array.isArray(jsonValue) && jsonValue.length === 0)) {
            const legacy = this.loadLegacyColumnsFromLocalStorage('dxPoolSettings2');
            if (legacy) {
                this.setState({ jsonData: legacy });
            }
        }
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
    }
    handleResize = () => {
        this.setState({
            isMobile: window.innerWidth <= 768
        });
    }


    async getData() {

        this.props.actions.isLoading(true)
        await this.props.actions.getAllTaskInPools(this.state.loginUser.ID, this.state.selectedPools);
        this.props.actions.isLoading(false)
    }


    getMyPoolUser() {
        callAPI(
            callApiGet,
            '/api/TaskTracking/GetMyPoolUsers',
            {},
            (poolUserss) => {
                this.setState({ poolUsers: poolUserss.data })

            },
            true
        );

    }
    checkAssignAJob(ID) {
        callAPI(
            callApiGet,
            '/api/TaskTracking/CheckAssignAJob?TaskID=' + ID,
            {},
            (res) => {
                if (res?.data) {
                    this.setState({ jobResponseUser: res.data })
                    this.setState({ buttonVisible: "none" })

                    if (res?.data.IsWieverTaskCreator) {
                        this.setState({ acceptDelete: "block" })


                    }
                    else {
                        this.setState({ acceptDelete: "none" })

                    }

                }
                else {
                    this.setState({ buttonVisible: "block" })
                }



            },
            true
        );
    }
    getMyPools() {

        var url = 'api/TaskTracking/GetMyPool'
        callAPI(
            callApiGet,
            url,
            {},
            async (res) => {
                {
                    this.setState({ myPools: res.data });
                }

            })

    }
    deleteJob(ID) {
        callAPI(
            callApiGet,
            '/api/TaskTracking/DeleteJob?TaskID=' + ID,
            {},
            (res) => {
                if (res?.data) {
                    this.setState({ isAssignJob: false, selectedUserId: undefined, taskID: undefined, selectedMessage: "", jobResponseUser: undefined, acceptDelete: "none" })
                    notify(this.languages.Görevbaşarıylasilindi, 'success', 2000);

                }


            },
            true
        );
    }

    handleChange = (key, value) => {
        if (key === 'redirect') {
            this.props.history.push('/TaskDetail?' + value)
        }
        if (key === 'isLoading') {
            this.props.actions.isLoading(true);
        }
        if (key === 'selectedUserId') {

            this.setState({ selectedUserId: value })

        }
        if (key === 'selectedMessage') {

            this.setState({ selectedMessage: value })

        }
    }

    onToolbarPreparing = (e) => {
        let ths = this;
        let {
            showDetail,
            selectedMainDropdown,
            isLoading,
            selectedTaskCreateDateStart,
            selectedPools,
            myPools,
            selectedTaskCreateDateEnd,
        } = this.state;
        let toolbarItems = e.toolbarOptions.items;
        let totalRow = this.languages.toplamTalepSayisi;
        totalRow += ths.props.poolTasks.length;
        const isMobile = window.innerWidth <= 768;
        toolbarItems.push({
            widget: "dxSelectBox",
            options: {
                dataSource: myPools,
                valueExpr: "ID",
                displayExpr: "Name",
                value: selectedPools,
                onValueChanged: function (e) {
                    ths.setState({ selectedPools: e.value })
                    ths.getData()
                },
                width: isMobile ? 100 : 170,

                textColor: "white",
                validationstatus: isLoading === true ? "pending" : "valid",
                onFocusIn: (event) => event.stopPropagation(),
                onFocusOut: (event) => {
                    event.preventDefault();
                    event.target.focus(); // Klavye kapanmasını engelle
                },
            },
            location: "after",
        });
        toolbarItems.push({
            widget: "dxButton",
            options: {
                icon: "save",
                onClick: () => {
                    this.handleSave();
                },
                stylingMode: "outlined",
                type: "default",
                width: 38,
                hint: "Kaydet",
                elementAttr: {
                    class: "custom-save-button",
                    style: "background-color: white !important; border: 1px solid black !important;"
                },
                onRendered: (e) => {
                    const icon = e.element.querySelector(".dx-icon");
                    if (icon) {
                        icon.style.color = "black";
                    }
                },
            },
            location: "after",
        });

        //Toplam Checkbox
        toolbarItems.unshift({
            location: 'center',
            template: 'totalGroupCount'
        });

        //Toplam Checkbox
        toolbarItems.unshift({
            location: 'before',
            template: 'pageName'
        });
    }
    handleSave = async () => {
        if (!this.gridRef || !this.gridRef.current || !this.gridRef.current.instance) {
            console.error("Grid referansı bulunamadı!");
            return;
        }

        const grid = this.gridRef.current.instance;

        // BBComponent ile tanımlı tüm dataField isimleri
        const allColumns = [
            "TaskNumber", "GorevCount", "CompanyName", "CreateUserCompanyDepartmentJobName",
            "CreateUserName", "AciklamaCount", "ParentCategory", "Category.Name", "DegreeOfUrgency",
            "NewDescription", "EkdosyaCount", "CreateDate", "ManagerUserName", "ExpectedEndDate",
            "TerminationDescription", "CreateUserCompanyDepartmentName", "SlaMinute", "ApprovalDate", "StatusName", "WorkStatus.Name", "ResponsibleUserName",
            "PoolName", "ProjectNumber", "TaskTerminationDescription", "TerminationDate"
        ];

        // Görünürlük, sıralama (visibleIndex) ve genişlik (width) topla
        const columnsState = {};
        allColumns.forEach((df) => {
            const visible = grid.columnOption(df, "visible");
            const visibleIndex = grid.columnOption(df, "visibleIndex");
            const width = grid.columnOption(df, "width");
            columnsState[df] = {
                visible: typeof visible === 'boolean' ? visible : false,
                visibleIndex: Number.isFinite(visibleIndex) ? visibleIndex : null,
                width: width ?? null
            };
        });

        const payload = {
            UserID: this.state.loginUser.ID,
            JsonValue: JSON.stringify(columnsState),
            ScreenType: 'TaskPool'
        };

        try {
            const response = await fetch('/api/Task/UpdateColumnChooser', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            if (!response.ok) {
                const err = await response.json().catch(() => ({}));
                notify(err?.message || this.languages.hata, 'error', 3000);
                return;
            }

            notify(this.languages.SütunlarbaşarıylaKaydedildi, 'success', 2000);
        } catch (error) {
            console.error("Hata:", error);
            notify(this.languages.hata, 'error', 3000);
        }
    };

    toolbarItemRender = (e) => {
        const isMobile = window.innerWidth <= 768;

        return (
            isMobile ? (
                <div style={{
                    width: '150px', height: '70px', textAlign: 'center', color: 'white', margin: '0px -350px 0px 90px', float: 'none'
                }}>
                    <span className="name">
                        {this.languages.toplamTalepSayisi} {this.props.poolTasks ? this.props.poolTasks.length : "0"}
                    </span>
                    <br />
                </div>
            ) : (
                <div className="informer">
                    <h3 className="count">{this.props.poolTasks.length}</h3>
                    <span className="name">{this.languages.toplamTalepSayisi}</span>
                </div>
            )
        );
    }

    addAssignAJob() {

        let jobDto = {
            TaskID: this.state.taskID,
            ResponsibleUserID: this.state.selectedUserId,
            Description: this.state.selectedMessage
        }
        let formData = new FormData();
        formData.append('jsonText', JSON.stringify(jobDto));
        this.props.actions.isLoading(true)
        callAPI(
            callApiPost,
            'api/TaskTracking/AddAssignAJob',
            formData,
            (res) => {
                if (res.data) {

                    this.getData();

                    this.setState({ isAssignJob: false })
                    notify(this.languages.Görevbaşarıylaatandı, 'success', 2000);
                    this.setState({ selectedUserId: undefined, taskID: undefined, selectedMessage: "", jobResponseUser: undefined, acceptDelete: "none" })
                    this.props.actions.isLoading(false)
                }
                else {
                    notify(this.languages.görevatanamadi, 'error', 2000);
                    this.props.actions.isLoading(false)
                }


            })
    }

    pageNameRender = (e) => {
        const isMobile = window.innerWidth <= 768;
        return (
            <div className="informer">
                <h5
                    className="count"
                    style={{
                        marginTop: 7,
                        marginLeft: 10,
                        display: isMobile ? 'none' : 'block'
                    }}
                >
                    <strong>{this.languages.talepHavuuzu}</strong>
                </h5>
            </div>
        );
    }
    getVisibleColumns = () => {
        const gridInstance = this.gridRef.current?.instance;  // gridRef ile ilgili instance'ı alıyoruz
        if (!gridInstance) return [];
        const columns = gridInstance.getVisibleColumns();  // Görünür sütunları alıyoruz
        return columns;
    };


    render() {
        const { t } = this.props;
        const { jsonData } = this.state;
        const visibleColumns = jsonData.map(item => {
            try {
                return {
                    field: JSON.parse(item.JsonValue),
                    visible: item.IsActive
                };
            } catch (error) {
                console.error("JSON parse hatası:", error);
                return {
                    field: {},
                    visible: false
                };
            }
        });
        return (
            <>
                <Row>
                    <Col xs="12" sm="12">
                        <CustomCard cardStyle='card-dashboard-calendar pb-0'>
                            <CardBody>
                                {Array.isArray(visibleColumns) && visibleColumns.length > 0 ? (
                                    BB.DxDataGridForOwnTaskPool(
                                        this.gridRef,  // Ref'i burada bağlıyoruz
                                        this.props.poolTasks,
                                        this,
                                        this.state.loginUser,
                                        this.state.isMobile,
                                        visibleColumns
                                    )
                                ) : (
                                    BB.DxDataGridForOwnTaskPoolDefault(
                                        this.props.poolTasks,
                                        this,
                                        this.state.loginUser,
                                        this.state.isMobile
                                    )
                                )}

                            </CardBody>

                        </CustomCard>
                    </Col>
                </Row>

                <Modal
                    style={{ zIndex: 1050 }}
                    centered={true}
                    isOpen={this.state.isAssignJob}
                    toggle={() => this.setState({
                        isAssignJob: false,
                        acceptDelete: "none",
                        selectedUserId: undefined,
                        taskID: undefined,
                        selectedMessage: "",
                        jobResponseUser: undefined
                    })}
                    onClosed={() => {
                        // Grid'i yeniden boyutlandır - modal kapandıktan sonra layout düzeltme
                        setTimeout(() => {
                            const grid = this.gridRef.current;
                            if (grid && grid.instance) {
                                if (typeof grid.instance.updateDimensions === 'function') {
                                    grid.instance.updateDimensions();
                                } else if (typeof grid.instance.refresh === 'function') {
                                    grid.instance.refresh();
                                }
                            }
                        }, 50); // Kısa bir delay modal animasyonunun bitmesini beklemek için
                    }}
                >
                    <ModalHeader>{t("görevAta")}</ModalHeader>
                    <ModalBody>

                        {BB.DxDropDownWithJSON(
                            "selectedUserId",
                            t("havuzKullanıcıları"),
                            this,
                            this.state.poolUsers
                        )}



                        {BB.TextAreaWithLabel('selectedMessage', t("mesaj"), t("mesaj"), 9, this)}

                        {/* <Row style={{ marginLeft: 0 }}>

           {this.state.jobResponseUser != undefined ? "Talep "+this.state.jobResponseUser.UserName+"' Kullanıcısına Görev Olarak Atanmıştır" :"" } 

           <div style={{display:this.state.acceptDelete}}>
           <Label
              color="danger"
             onClick={() => this.deleteJob(this.state.taskID)}
              className="ml-2"
              style={{cursor:"pointer",color:"red"}}
            >
             X
            </Label> 
                      </div>
                        </Row>  */}

                        <Row style={{ float: 'right', marginRight: 10 }}>
                            <Button style={{ marginRight: 7 }}
                                color={'info'}
                                onClick={() => this.setState({ isAssignJob: false, acceptDelete: "none", selectedUserId: undefined, taskID: undefined, selectedMessage: "", jobResponseUser: undefined })}>
                                {t("vazgec")}
                            </Button>
                            {/* <div style={{  display: this.state.buttonVisible}}> */}
                            <div>
                                <Button

                                    color={'success'}
                                    onClick={() => this.addAssignAJob()}


                                >{t("onayVer")}</Button></div>

                        </Row>

                    </ModalBody>
                </Modal>
            </>



        );
    }
}

function mapStateToProps(state) {
    return {
        loginUser: state.loginReducer,
        poolTasks: state.poolReducer
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            isLoading: bindActionCreators(loadingActions.setLoading, dispatch),
            getAllTaskInPools: bindActionCreators(poolActions.getAllPoolTask, dispatch),
        }
    }
}

export default withRouter(withTranslation()(connect(mapStateToProps, mapDispatchToProps)(TaskPool)))

